@let client = (client$ |async);

<div id="side-menu" [@menuAnimation]="menuState" (mouseenter)="toggleMenuState('open')"
    (mouseleave)="toggleMenuState('close')">

    <img id="svet-icon" src="assets/icons/svet-icon.svg" alt="">
    
    <!-- <div>
        <lucide-icon color="#919A96" class="chevrons-right" name="chevronsLeft" size="28"></lucide-icon>
        <lucide-icon color="#919A96" class="chevrons-right" name="chevrons-right" size="28"></lucide-icon>
    </div> -->

    <!-- CLIENT MENU -->
    <div class="client-element" [ngClass]="menuState" routerLink="profile">
        @if(client){
        <img class="avatar"
            [src]="client.avatar ? client.avatar : 'https://ui-avatars.com/api/?name='+ client.username" alt="">
        <div class="client-menu-data" [ngClass]="menuState">
            <p class="client-name text-ellipsis">{{client.username}}</p>
            <p class="client-email text-ellipsis">{{client.email}}</p>
        </div>
        }
    </div>

    <div class="tokens-left-btn" [ngClass]="menuState" [routerLink]="['/dashboard/plans']">
        {{ (tokensLeft$ | async) || 0 | roundToK }}
        @if(menuState == 'open'){
        <div class="unit" [ngClass]="menuState">
            {{ 'common.tokens' | translate }}
        </div>
        }
    </div>

    <div class="side-menu-divider"></div>

    <div class="main-menu-items-container">
        @for(item of menuItems;track $index){
        <div class="menu-item" [ngClass]="item.active ? 'menu-item-active' : 'menu-item'" [routerLink]="item.route">
            @let notificationsCount = (notificationsCount$ | async);
            @if(item.name === 'notifications' && notificationsCount && notificationsCount > 0){
                <div class="notifications">{{ notificationsCount$ | async }}</div>
            }
            <lucide-icon [name]="item.icon"
                [color]="item.active ? light : light300" size="28"></lucide-icon>
            <p  [ngStyle]="{color:item.active ? light : light300}" class="text-ellipsis">{{ 'nav.' + item.name + '.menu_title' | translate |
                titlecase }}</p>
        </div>
        }
    </div>

    <div class="menu-items-container">
        @for(item of bottomMenuItems;track $index){
        <div class="menu-item" [ngClass]="item.active ? 'menu-item-active' : 'menu-item'" [routerLink]="item.route">
            <lucide-icon [name]="item.icon" [color]="item.active ? light : light300" size="28"></lucide-icon>
            <p class="text-ellipsis">{{ 'nav.' + item.name + '.menu_title' | translate |
                titlecase }}</p>
        </div>
        }
    </div>

    <div class="side-menu-divider"></div>

    <div class="socials-container">
        <a class="static-social" target="_blank" href="https://discord.gg/2nzAZ5ZqFa">
            <img src="assets/icons/discord.svg" alt="">
        </a>

        <!-- <a class="social" [ngClass]="menuState" target="_blank" href="https://discord.gg/2nzAZ5ZqFa">
            <img src="assets/icons/reddit.svg" alt="">
        </a> -->
        <!-- <a class="social" [ngClass]="menuState" target="_blank" href="https://discord.gg/2nzAZ5ZqFa">
            <img src="assets/icons/instagram.svg" alt="">
        </a> -->
    </div>

</div>